module.exports = "/resources/assets/prod/db1c3652c61ce505821015f4ae587482.svg";